import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import CardContent from "@material-ui/core/CardContent";
import Card from "@material-ui/core/Card";
import Button from "@material-ui/core/Button";
import { useNavigate } from "react-router-dom";
import CircularProgress from "@material-ui/core/CircularProgress";
import { fetchWithToken } from "../../../apiUtils";

const useStyles = makeStyles({
  root: {
    flexGrow: 1,
  },
  card: {
    marginTop: 40,
  },
  checkbox: {
    width: "25px",
    height: "25px",
  },
  title: {
    textAlign: "center",
  },
  button: {
    margin: "5px",
  },
  loading: {
    marginTop: "25%",
    marginLeft: "50%",
  },
});

const EditQueue = () => {
  const { queueId } = useParams();
  const classes = useStyles();

  const [formData, setFormData] = useState({
    queue: [],
    loading: true,
  });

  useEffect(() => {
    axios
      .get(`/Queues/${queueId}`)
      .then((response) => {
        setFormData({
          queue: response.data,
          loading: false,
        });
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          console.error("Authentication error: Please log in again.");
        } else {
          console.error("Error fetching queue details:", error);
        }
      });
  }, []);

  return (
    <>
      {formData.loading ? (
        <CircularProgress className={classes.loading} />
      ) : (
        <EditForm formData={formData.queue} />
      )}
    </>
  );
};

const EditForm = ({ formData: formData }) => {
  const classes = useStyles();
  const history = useNavigate();

  const queue = formData;

  const [queueData, setQueueData] = useState({
    id: queue.id,
    gmid: queue.gmid,
    submitDate: queue.submitDate,
    siteName: queue.siteId,
    priority: queue.priority,
  });

  console.log(queueData);

  const myChangeHandler = (e) => {
    const target = e.target;
    const value = target.value;
    const name = target.name;

    setQueueData({
      ...queueData,
      [name]: value,
    });
  };

  const handleCancel = () => {
    history.goBack();
  };

  const submitHandler = (e) => {
    e.preventDefault();

    console.log("Submitting", queueData);

    fetchWithToken(`api/Queues/${queue.id}`, "PUT", queueData).then((data) => {
      console.log(data); // JSON data parsed by `data.json()` call
    });

    // Needs to be fixed -
    history("/manageQueueStatus");
    history.go(0);
  };

  return (
    <>
      <div class="row">
        <div class="col-md-8 offset-md-2">
          <Card className={classes.card}>
            <CardContent>
              <form onSubmit={submitHandler}>
                <h1 className={classes.title}>Edit Queue</h1>
                <br />
                <div class="mb-3 row">
                  <label class="col-sm-3 col-form-label">
                    <h5>Queue ID:</h5>
                  </label>
                  <div class="col-sm-9">
                    <h5>{queue.id}</h5>
                  </div>
                </div>

                <div class="mb-3 row">
                  <label class="col-sm-3 col-form-label">
                    <h5>Priority:</h5>
                  </label>
                  <select
                    class="form-control"
                    defaultValue={queue.priority}
                    name="priority"
                    style={{ width: "200px" }}
                    onChange={myChangeHandler}
                  >
                    <option value="1" align="center">
                      High
                    </option>
                    <option value="2" align="center">
                      Medium
                    </option>
                    <option value="3" align="center">
                      Low
                    </option>
                  </select>
                </div>

                <br />

                <Button
                  type="submit"
                  variant="contained"
                  className={classes.button}
                  color="primary"
                >
                  Update
                </Button>
                <Button
                  variant="contained"
                  className={classes.button}
                  onClick={handleCancel}
                >
                  Cancel
                </Button>
              </form>
            </CardContent>
          </Card>
        </div>
      </div>
    </>
  );
};

export default EditQueue;
